/** Auto generated file, do not edit, run rake framework_models:update_js */
import EnumValue from './EnumValue';
import type * as AhaTypes from './models/generated/types';

export class Enum {
  static enums: Record<string, Enum> = {};

  constructor(public name: string, public values: any[]) {
    values.forEach(value => {
      Object.defineProperty(this, value, {
        get() {
          return new EnumValue(name, value);
        },
      });
    });

    Enum.enums[name] = this;
  }
}

export const AgentScopeEnum = new Enum('AgentScopeEnum', [
  'GLOBAL',
  'WORKSPACE',
  'PERSONAL',
]) as unknown as AhaTypes.AgentScopeEnum;

export const AgentTypeEnum = new Enum('AgentTypeEnum', [
  'INSTRUCTION',
  'AGENT',
  'PROMPT',
]) as unknown as AhaTypes.AgentTypeEnum;

export const AiRequestKindEnum = new Enum('AiRequestKindEnum', [
  'WRITE',
  'REWRITE',
]) as unknown as AhaTypes.AiRequestKindEnum;

export const AiRequestOrder = new Enum('AiRequestOrder', [
  'createdAt',
]) as unknown as AhaTypes.AiRequestOrder;

export const AnnotatableTypeEnum = new Enum('AnnotatableTypeEnum', [
  'Note',
  'DiscoveryScriptPromptUse',
]) as unknown as AhaTypes.AnnotatableTypeEnum;

export const AnnotationTypeEnum = new Enum('AnnotationTypeEnum', [
  'POINT',
  'TEXT',
  'WHITEBOARDOBJECT',
  'QUOTE',
  'PROMPT',
  'LEARNING',
  'RECORD',
  'SUMMARY',
]) as unknown as AhaTypes.AnnotationTypeEnum;

export const AttachmentSizeEnum = new Enum('AttachmentSizeEnum', [
  'MINI',
  'MEDIUM',
  'ORIGINAL',
]) as unknown as AhaTypes.AttachmentSizeEnum;

export const AvatarSizeEnum = new Enum('AvatarSizeEnum', [
  'SIZE_16',
  'SIZE_24',
  'SIZE_32',
  'SIZE_40',
  'SIZE_160',
]) as unknown as AhaTypes.AvatarSizeEnum;

export const CardFieldTypesEnum = new Enum('CardFieldTypesEnum', [
  'STANDARD_FIELD',
  'CUSTOM_FIELD',
  'CUSTOM_FIELD_SET',
  'CUSTOM_OBJECT_LINK',
]) as unknown as AhaTypes.CardFieldTypesEnum;

export const CardLayoutRecordTypesEnum = new Enum('CardLayoutRecordTypesEnum', [
  'Epic',
  'Feature',
  'Idea',
  'Initiative',
  'Release',
  'ReleasePhase',
  'Requirement',
  'Task',
  'Goal',
]) as unknown as AhaTypes.CardLayoutRecordTypesEnum;

export const CardStylingTypesEnum = new Enum('CardStylingTypesEnum', [
  'AgingRecord',
  'SidebarStatus',
  'BackgroundStatus',
  'BackgroundFeatureType',
  'NoStyling',
]) as unknown as AhaTypes.CardStylingTypesEnum;

export const ChatOrder = new Enum('ChatOrder', [
  'createdAt',
  'updatedAt',
]) as unknown as AhaTypes.ChatOrder;

export const CommentableTypeEnum = new Enum('CommentableTypeEnum', [
  'Task',
  'Release',
  'Epic',
  'Page',
  'Iteration',
  'Feature',
  'Goal',
  'Initiative',
  'Idea',
  'Requirement',
  'ReleasePhase',
  'IdeaTheme',
  'KeyResult',
  'ProgramIncrement',
  'PdlcStep',
  'Annotation',
  'DiscoveryInterview',
  'Competitor',
  'Poll',
  'Persona',
  'Presentation',
]) as unknown as AhaTypes.CommentableTypeEnum;

export const CustomFieldDefinitionTypeEnum = new Enum(
  'CustomFieldDefinitionTypeEnum',
  [
    'UrlField',
    'TextField',
    'ScorecardField',
    'RecordsField',
    'NumberField',
    'NoteField',
    'LinkCustomFieldDefinition',
    'EquationField',
    'DateField',
    'AttachmentField',
    'UsersField',
    'StrategicImperativesField',
    'ReleasesField',
    'ProjectsField',
    'PersonasField',
    'KeyResultsField',
    'InitiativesField',
    'IdeasField',
    'IdeaOrganizationsField',
    'IdeaCategoriesField',
    'FeaturesField',
    'EpicsField',
    'CreativeBriefsField',
    'CompetitorsField',
    'LinkMasterDetail',
    'LinkMany',
    'LinkOne',
    'SelectMultipleEditable',
    'SelectMultipleConstant',
    'SelectEditable',
    'SelectConstant',
  ]
) as unknown as AhaTypes.CustomFieldDefinitionTypeEnum;

export const CustomFieldableTypeEnum = new Enum('CustomFieldableTypeEnum', [
  'Project',
  'Task',
  'Release',
  'Epic',
  'SchedulingTeam',
  'Page',
  'Feature',
  'Goal',
  'Initiative',
  'Idea',
  'Requirement',
  'ReleasePhase',
  'IdeaUser',
  'KeyResult',
  'ProgramIncrement',
  'NoteTemplate',
  'Competitor',
  'Persona',
  'IdeaOrganization',
]) as unknown as AhaTypes.CustomFieldableTypeEnum;

export const DiscoveryInterviewMode = new Enum('DiscoveryInterviewMode', [
  'in_person',
  'phone',
  'video',
  'focus_group',
  'observation',
  'document_analysis',
]) as unknown as AhaTypes.DiscoveryInterviewMode;

export const DiscoveryInterviewStatus = new Enum('DiscoveryInterviewStatus', [
  'scheduling',
  'scheduled',
  'processing',
  'analyzing',
  'completed',
  'canceled',
]) as unknown as AhaTypes.DiscoveryInterviewStatus;

export const DiscoveryResearchItemItemType = new Enum(
  'DiscoveryResearchItemItemType',
  ['goal', 'assumption', 'learning', 'action']
) as unknown as AhaTypes.DiscoveryResearchItemItemType;

export const DiscoveryResearchableType = new Enum('DiscoveryResearchableType', [
  'DiscoveryStudy',
]) as unknown as AhaTypes.DiscoveryResearchableType;

export const DiscoveryStudyStatus = new Enum('DiscoveryStudyStatus', [
  'planned',
  'in_progress',
  'postponed',
  'completed',
  'canceled',
]) as unknown as AhaTypes.DiscoveryStudyStatus;

export const DocumentTypeEnum = new Enum('DocumentTypeEnum', [
  'NOTE',
  'WHITEBOARD',
  'FOLDER',
  'DAILY_NOTES_FOLDER',
  'MEETING_NOTE',
  'MEETING_WHITEBOARD',
  'EXTERNAL_LINK',
  'INTERNAL_LINK',
  'DISCOVERY_DOCUMENTS_FOLDER',
  'FILE',
]) as unknown as AhaTypes.DocumentTypeEnum;

export const EditorWidthEnum = new Enum('EditorWidthEnum', [
  'NARROW',
  'FULL',
]) as unknown as AhaTypes.EditorWidthEnum;

export const EpicOrder = new Enum('EpicOrder', [
  'workflowBoardPosition',
  'createdAt',
  'position',
]) as unknown as AhaTypes.EpicOrder;

export const ExtensionAutomationRecordEnum = new Enum(
  'ExtensionAutomationRecordEnum',
  ['Feature', 'Epic', 'Requirement']
) as unknown as AhaTypes.ExtensionAutomationRecordEnum;

export const ExtensionFieldableTypeEnum = new Enum(
  'ExtensionFieldableTypeEnum',
  [
    'USER',
    'ITERATION',
    'FEATURE',
    'REQUIREMENT',
    'ACCOUNT',
    'RELEASE',
    'EPIC',
    'MASTERRELEASE',
  ]
) as unknown as AhaTypes.ExtensionFieldableTypeEnum;

export const FeatureOrder = new Enum('FeatureOrder', [
  'workflowBoardPosition',
  'createdAt',
  'updatedAt',
  'position',
  'featureBoardPosition',
]) as unknown as AhaTypes.FeatureOrder;

export const GoalOrder = new Enum('GoalOrder', [
  'position',
]) as unknown as AhaTypes.GoalOrder;

export const HasAccessRestrictionsTypeEnum = new Enum(
  'HasAccessRestrictionsTypeEnum',
  ['Page']
) as unknown as AhaTypes.HasAccessRestrictionsTypeEnum;

export const IdeaBoardGroupBy = new Enum('IdeaBoardGroupBy', [
  'ASSIGNEE',
  'PROJECT',
  'THEME',
  'CATEGORY',
]) as unknown as AhaTypes.IdeaBoardGroupBy;

export const IdeaCategoryOrder = new Enum('IdeaCategoryOrder', [
  'name',
  'createdAt',
  'updatedAt',
]) as unknown as AhaTypes.IdeaCategoryOrder;

export const IdeaOrder = new Enum('IdeaOrder', [
  'createdAt',
  'updatedAt',
  'popularity',
  'assignedToUser',
]) as unknown as AhaTypes.IdeaOrder;

export const IdeaPromotableTypeEnum = new Enum('IdeaPromotableTypeEnum', [
  'Feature',
  'Epic',
  'Requirement',
]) as unknown as AhaTypes.IdeaPromotableTypeEnum;

export const IdeaThemeOrder = new Enum('IdeaThemeOrder', [
  'name',
  'createdAt',
  'updatedAt',
]) as unknown as AhaTypes.IdeaThemeOrder;

export const InitiativeOrder = new Enum('InitiativeOrder', [
  'position',
]) as unknown as AhaTypes.InitiativeOrder;

export const InternalMeaning = new Enum('InternalMeaning', [
  'NOT_STARTED',
  'IN_PROGRESS',
  'DONE',
  'SHIPPED',
  'WONT_DO',
  'ALREADY_EXISTS',
]) as unknown as AhaTypes.InternalMeaning;

export const IterationOrder = new Enum('IterationOrder', [
  'startDate',
]) as unknown as AhaTypes.IterationOrder;

export const KnowledgeBaseAuthenticationMethodEnum = new Enum(
  'KnowledgeBaseAuthenticationMethodEnum',
  ['NONE', 'PASSWORD', 'SSO']
) as unknown as AhaTypes.KnowledgeBaseAuthenticationMethodEnum;

export const LinkableRecordTypesEnum = new Enum('LinkableRecordTypesEnum', [
  'Epic',
  'Feature',
  'Idea',
  'Initiative',
  'KeyResult',
  'Page',
  'Persona',
  'Release',
  'ReleasePhase',
  'Requirement',
  'Goal',
  'PdlcStep',
  'Annotation',
  'Competitor',
  'DiscoveryInterview',
  'Task',
]) as unknown as AhaTypes.LinkableRecordTypesEnum;

export const MessageRole = new Enum('MessageRole', [
  'assistant',
  'user',
]) as unknown as AhaTypes.MessageRole;

export const NotificationOrder = new Enum('NotificationOrder', [
  'createdAt',
]) as unknown as AhaTypes.NotificationOrder;

export const NotificationReadEnum = new Enum('NotificationReadEnum', [
  'READ',
  'UNREAD',
]) as unknown as AhaTypes.NotificationReadEnum;

export const NotificationScopeEnum = new Enum('NotificationScopeEnum', [
  'PARTICIPATING',
  'WATCHING',
]) as unknown as AhaTypes.NotificationScopeEnum;

export const NotificationStarredEnum = new Enum('NotificationStarredEnum', [
  'STARRED',
  'UNSTARRED',
]) as unknown as AhaTypes.NotificationStarredEnum;

export const NotificationTypeEnum = new Enum('NotificationTypeEnum', [
  'Comment',
  'Project',
  'Task',
  'Release',
  'Epic',
  'Page',
  'Feature',
  'Goal',
  'Initiative',
  'Idea',
  'ProgramIncrement',
  'DiscoveryStudy',
  'DiscoveryInterview',
  'Competitor',
  'Persona',
]) as unknown as AhaTypes.NotificationTypeEnum;

export const OrderDirection = new Enum('OrderDirection', [
  'ASC',
  'DESC',
]) as unknown as AhaTypes.OrderDirection;

export const PageOrder = new Enum('PageOrder', [
  'createdAt',
  'updatedAt',
  'position',
  'name',
  'recentlyViewed',
  'documentDate',
]) as unknown as AhaTypes.PageOrder;

export const PageShareLinkOrder = new Enum('PageShareLinkOrder', [
  'createdAt',
]) as unknown as AhaTypes.PageShareLinkOrder;

export const PlaceableRecordTypeEnum = new Enum('PlaceableRecordTypeEnum', [
  'Feature',
  'Epic',
  'Requirement',
  'Idea',
  'IdeaThemeIdea',
  'IdeaCategorization',
  'Initiative',
]) as unknown as AhaTypes.PlaceableRecordTypeEnum;

export const PortalVisibilityTypeEnum = new Enum('PortalVisibilityTypeEnum', [
  'VISIBILITY_AHA',
  'VISIBILITY_CREATOR',
  'VISIBILITY_EMPLOYEE',
  'VISIBILITY_EMPLOYEE_OR_CREATOR',
  'VISIBILITY_PUBLIC',
]) as unknown as AhaTypes.PortalVisibilityTypeEnum;

export const PositionableRecordsBookmarkTypesEnum = new Enum(
  'PositionableRecordsBookmarkTypesEnum',
  ['WORKFLOW_BOARD', 'TEAM_BACKLOG', 'ITERATION']
) as unknown as AhaTypes.PositionableRecordsBookmarkTypesEnum;

export const ProgramIncrementIterationOrder = new Enum(
  'ProgramIncrementIterationOrder',
  ['startDate']
) as unknown as AhaTypes.ProgramIncrementIterationOrder;

export const ProgramIncrementOrder = new Enum('ProgramIncrementOrder', [
  'startDate',
]) as unknown as AhaTypes.ProgramIncrementOrder;

export const PublishingStateEnum = new Enum('PublishingStateEnum', [
  'NONE',
  'UNPUBLISHED',
  'PUBLISHED',
  'MODIFIED',
  'UNPUBLISHED_AND_MODIFIED',
  'UNPUBLISHED_AND_PUBLISHED',
  'MODIFIED_AND_PUBLISHED',
]) as unknown as AhaTypes.PublishingStateEnum;

export const RecordEventGroupByEnum = new Enum('RecordEventGroupByEnum', [
  'ITERATION_ID',
  'RELEASE_ID',
  'EPIC_ID',
  'FEATURE_ID',
  'REQUIREMENT_ID',
  'TEAM_ID',
  'TEAM_WORKFLOW_STATUS_ID',
  'ASSIGNED_TO_USER_ID',
]) as unknown as AhaTypes.RecordEventGroupByEnum;

export const RecordEventSubjectEnum = new Enum('RecordEventSubjectEnum', [
  'Release',
  'Epic',
  'Iteration',
  'Feature',
  'Requirement',
]) as unknown as AhaTypes.RecordEventSubjectEnum;

export const RecordEventTimeSeriesGroupEnum = new Enum(
  'RecordEventTimeSeriesGroupEnum',
  ['HOUR', 'DAY', 'WEEK', 'MONTH']
) as unknown as AhaTypes.RecordEventTimeSeriesGroupEnum;

export const RecordEventTypeEnum = new Enum('RecordEventTypeEnum', [
  'ITERATION_START',
  'ITERATION_COMPLETED',
  'ITERATION_CAPACITY_CHANGED',
  'RELEASE_CAPACITY_CHANGED',
  'EPIC_CAPACITY_CHANGED',
  'FEATURE_CAPACITY_CHANGED',
  'REQUIREMENT_CAPACITY_CHANGED',
  'RECORD_WORK_DONE',
  'RECORD_ESTIMATE_CHANGED',
  'RECORD_REMAINING_CHANGED',
  'RECORD_COMPLETED',
  'RECORD_RESTARTED',
  'RECORD_ADDED_TO_ITERATION',
  'RECORD_REMOVED_FROM_ITERATION',
  'RECORD_ADDED_TO_RELEASE',
  'RECORD_REMOVED_FROM_RELEASE',
  'RECORD_ADDED_TO_EPIC',
  'RECORD_REMOVED_FROM_EPIC',
  'RECORD_ADDED_TO_FEATURE',
  'RECORD_REMOVED_FROM_FEATURE',
  'RECORD_ADDED_TO_TEAM',
  'RECORD_REMOVED_FROM_TEAM',
  'RECORD_ADDED_TO_TEAM_WORKFLOW_STATUS',
  'RECORD_REMOVED_FROM_TEAM_WORKFLOW_STATUS',
  'RECORD_ADDED_TO_ASSIGNED_USER',
  'RECORD_REMOVED_FROM_ASSIGNED_USER',
  'RECORD_ADDED_TO_PROGRAM_INCREMENT',
  'RECORD_REMOVED_FROM_PROGRAM_INCREMENT',
  'RECORD_ITERATION_START',
  'RECORD_INCOMPLETE_MOVED',
]) as unknown as AhaTypes.RecordEventTypeEnum;

export const RecordEventValueOperationEnum = new Enum(
  'RecordEventValueOperationEnum',
  ['SUM', 'MIN', 'MAX', 'AVG', 'COUNT']
) as unknown as AhaTypes.RecordEventValueOperationEnum;

export const RecordLinkTypeEnum = new Enum('RecordLinkTypeEnum', [
  'RELATES_TO',
  'DEPENDS_ON',
  'DUPLICATES',
  'CONTAINS',
  'IMPACTS',
  'BLOCKS',
  'RELEASE_NOTES_FOR',
  'HAS_RESEARCH_IN',
  'INSTRUCTION_FOR',
  'MEETING_FOR',
]) as unknown as AhaTypes.RecordLinkTypeEnum;

export const RecordPlacementEnum = new Enum('RecordPlacementEnum', [
  'TOP',
  'BOTTOM',
]) as unknown as AhaTypes.RecordPlacementEnum;

export const RecordPlacementPositionEnum = new Enum(
  'RecordPlacementPositionEnum',
  ['TOP', 'BOTTOM', 'BEFORE', 'AFTER']
) as unknown as AhaTypes.RecordPlacementPositionEnum;

export const RecordReferenceTypeEnum = new Enum('RecordReferenceTypeEnum', [
  'Feature',
  'Epic',
  'Requirement',
  'Idea',
  'IdeaThemeIdea',
  'IdeaCategorization',
  'Initiative',
  'KeyResult',
]) as unknown as AhaTypes.RecordReferenceTypeEnum;

export const ReleaseOrder = new Enum('ReleaseOrder', [
  'featuresBoardOrder',
  'developmentStartedOn',
]) as unknown as AhaTypes.ReleaseOrder;

export const ReleasePhaseTypeEnum = new Enum('ReleasePhaseTypeEnum', [
  'Milestone',
  'Phase',
]) as unknown as AhaTypes.ReleasePhaseTypeEnum;

export const ReleaseResourceEventKindEnum = new Enum(
  'ReleaseResourceEventKindEnum',
  [
    'IMPLEMENTED',
    'REOPENED',
    'REMAINING_REDUCED',
    'REMAINING_INCREASED',
    'INCLUDED_RECORD',
    'REMOVED_RECORD',
    'WONT_IMPLEMENT',
    'INCREASED_ESTIMATE',
    'REDUCED_ESTIMATE',
    'INCLUDED_REMAINING_RECORD',
    'REMOVED_REMAINING_RECORD',
    'INCREASED_WORK_DONE',
    'REDUCED_WORK_DONE',
  ]
) as unknown as AhaTypes.ReleaseResourceEventKindEnum;

export const ReprioritizeByTypeEnum = new Enum('ReprioritizeByTypeEnum', [
  'SCORE_FACT',
  'SCORE',
]) as unknown as AhaTypes.ReprioritizeByTypeEnum;

export const RequirementOrder = new Enum('RequirementOrder', [
  'workflowBoardPosition',
  'createdAt',
  'updatedAt',
  'position',
]) as unknown as AhaTypes.RequirementOrder;

export const ReviewerDocumentAccessEnum = new Enum(
  'ReviewerDocumentAccessEnum',
  ['inherit', 'view', 'edit']
) as unknown as AhaTypes.ReviewerDocumentAccessEnum;

export const ScreenableTypeEnum = new Enum('ScreenableTypeEnum', [
  'Task',
  'Release',
  'Epic',
  'Feature',
  'Goal',
  'Initiative',
  'Idea',
  'Requirement',
]) as unknown as AhaTypes.ScreenableTypeEnum;

export const SharedPageAccessEnum = new Enum('SharedPageAccessEnum', [
  'READ_ONLY',
  'READ_ANNOTATE',
  'READ_WRITE',
]) as unknown as AhaTypes.SharedPageAccessEnum;

export const SharedPageOrder = new Enum('SharedPageOrder', [
  'createdAt',
]) as unknown as AhaTypes.SharedPageOrder;

export const SortChildPageTypeEnum = new Enum('SortChildPageTypeEnum', [
  'createdAt',
  'name',
]) as unknown as AhaTypes.SortChildPageTypeEnum;

export const SprintPlanningEstimatesEnum = new Enum(
  'SprintPlanningEstimatesEnum',
  ['REMAINING_ESTIMATE', 'INITIAL_ESTIMATE']
) as unknown as AhaTypes.SprintPlanningEstimatesEnum;

export const TagTypeEnum = new Enum('TagTypeEnum', [
  'GENERAL',
  'INTERVIEW',
]) as unknown as AhaTypes.TagTypeEnum;

export const TaskOrder = new Enum('TaskOrder', [
  'createdAt',
  'updatedAt',
  'dueDate',
  'name',
]) as unknown as AhaTypes.TaskOrder;

export const TaskStatusEnum = new Enum('TaskStatusEnum', [
  'PENDING',
  'COMPLETE',
  'APPROVED',
  'APPROVED_CONDITIONALLY',
  'REJECTED',
  'SKIPPED',
]) as unknown as AhaTypes.TaskStatusEnum;

export const TaskTypeEnum = new Enum('TaskTypeEnum', [
  'TASK',
  'APPROVAL',
  'WORKREQUEST',
]) as unknown as AhaTypes.TaskTypeEnum;

export const TaskUserOrder = new Enum('TaskUserOrder', [
  'completedDate',
]) as unknown as AhaTypes.TaskUserOrder;

export const TeamAssignableTypeEnum = new Enum('TeamAssignableTypeEnum', [
  'Epic',
  'Feature',
  'Requirement',
]) as unknown as AhaTypes.TeamAssignableTypeEnum;

export const TeamFlavorEnum = new Enum('TeamFlavorEnum', [
  'ROADMAPS',
  'DEVELOP',
  'TEAMWORK',
]) as unknown as AhaTypes.TeamFlavorEnum;

export const ToolCallStatus = new Enum('ToolCallStatus', [
  'preparing',
  'needs_approval',
  'processing',
  'complete',
  'error',
  'rejected',
  'needs_frontend_content',
  'interrupted',
  'incomplete',
]) as unknown as AhaTypes.ToolCallStatus;

export const UserRestrictionOverrideAccessEnum = new Enum(
  'UserRestrictionOverrideAccessEnum',
  ['CONTRIBUTOR', 'REVIEWER', 'VIEWER']
) as unknown as AhaTypes.UserRestrictionOverrideAccessEnum;

export const WorkUnitEnum = new Enum('WorkUnitEnum', [
  'MINUTES',
  'POINTS',
  'HEADCOUNT',
]) as unknown as AhaTypes.WorkUnitEnum;

export const WorkflowMeaningEnum = new Enum('WorkflowMeaningEnum', [
  'NOT_STARTED',
  'IN_PROGRESS',
  'DONE',
  'SHIPPED',
  'WONT_DO',
  'ALREADY_EXISTS',
]) as unknown as AhaTypes.WorkflowMeaningEnum;

export const WorkspaceRestrictionEnum = new Enum('WorkspaceRestrictionEnum', [
  'DEFAULT',
  'VIEWER',
  'REVIEWER',
  'NONE',
]) as unknown as AhaTypes.WorkspaceRestrictionEnum;
